import { find } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import patientSelector from '../../selectors/PatientSelector';

const AppointmentStackingError = ({ patientState, patientId }) => {
    const getSelectedPatientName = (patientState, patientId) => {
        if (patientState && patientId) {
            const patientIdAsInt = parseInt(patientId, 10);
            if (
                patientState.patientFirstName &&
                patientState.patientId === patientIdAsInt
            ) {
                return `${patientState.patientFirstName} ${patientState.patientLastName}`;
            } else {
                const subPatient = find(
                    patientState.subpatients,
                    (x) => x.patientId === patientIdAsInt
                );
                if (subPatient) {
                    return `${subPatient.firstName} ${subPatient.lastName}`;
                }
            }
        }
        return undefined;
    };

    const patientName = getSelectedPatientName(patientState, patientId);

    return (
        <p data-test="appointment-stacking-error-description">
            {patientName ? `${patientName} has` : 'You have'} a similar
            appointment coming up. You can make changes to the existing
            appointment if you need to.
        </p>
    );
};

const mapStateToProps = (state) => {
    const patientState = patientSelector(state);

    return { patientState };
};

export const AppointmentStackingErrorDescription = connect(mapStateToProps)(
    AppointmentStackingError
);
